import React from 'react';
import { useSearchWorkspace } from '../../contexts/SearchWorkspaceContext';
import SearchTileSizeControlView from './SearchTileSizeControlView';

const SearchTileSizeControl: React.FC = () => {
  const { tileSize, setTileSize } = useSearchWorkspace();
  return <SearchTileSizeControlView tileSize={tileSize} setTileSize={setTileSize} />;
};
export default SearchTileSizeControl;
